import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { ToasterContext } from "./ToasterContext.js";
import { useComponentClassName } from "../../auxiliary/useComponentClassName.js";
import { Message } from "../Message/Message.js";
import { Button } from "../Forms/Button/Button.js";
import { Icon } from "../Icon/Icon.js";
const toastTypeToIntent = {
  success: "success",
  warning: "warn",
  error: "danger",
  info: "positive"
};
const Toaster = () => {
  const toasterContext = useContext(ToasterContext);
  if (!toasterContext) {
    throw new Error("Toaster context is not initialized");
  }
  const componentClassName = useComponentClassName("toaster");
  return /* @__PURE__ */ jsx("div", { className: componentClassName, children: /* @__PURE__ */ jsx("div", { className: `${componentClassName}-inner`, children: toasterContext.toasts.map((toast) => /* @__PURE__ */ jsx("div", { className: `${componentClassName}-item`, children: /* @__PURE__ */ jsx(
    Message,
    {
      intent: toastTypeToIntent[toast.type],
      flow: "block",
      lifted: true,
      distinction: "striking",
      action: /* @__PURE__ */ jsx(
        Button,
        {
          distinction: "seamless",
          flow: "squarish",
          onClick: () => {
            toasterContext.dismissToast(toast.id);
          },
          children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "cross" })
        }
      ),
      children: toast.message
    }
  ) }, toast.id)) }) });
};
export {
  Toaster
};
//# sourceMappingURL=Toaster.js.map
